<template>
	<header :class="[{'header-absolute': absolute}]">

		<div class="before">
			 <v-btn
	          v-if="btnToggle"
	          fab
	          class="mr-4"
	          color="primary"
	          elevation="2"
	          @click="$emit('toggle')"
	    >
	          <v-icon>
	                mdi-menu
	          </v-icon>
	    </v-btn>

			<!-- Slot(before)  -->
			<slot name="before"></slot>

			<!-- Logo -->
			<img src="https://apps.pinturasacuario.mx/assets/logo-blanco-transparente.png" alt="" @click="redirect()">
		</div>

		<!-- Slot(seeker)  -->
		<div class="center">
			<slot name="seeker"></slot>
		</div>

		<div class="after">			
			<!-- Slot After -->
			<slot name="after"></slot>
		</div>

		<div class="menus-container">
			<!-- Slot(menus) -->
			<slot name="menus"></slot>
		</div>
	</header>
</template>

<script>
import { EventBus } from "@/main"

export default {
  props: {
  	routenameredirect: {
  		type: String,
  		required: false,
  	},

  	absolute: {
  		required: false,
  	},

  	btnToggle: {
  		required: false,
  		default: true,
  		type: Boolean
  	}
  },

  data () {
    return {

    }
  },

  methods: {
  	redirect(){
  		if (this.routenameredirect) {
				this.$router.push({name: this.routenameredirect})
  		}
  	}
  },
}
</script>

<style lang="css" scoped>


.before, .center, .after{
	display: flex;
	height: 100%;
	align-items: center;
}

.before{
	justify-content: flex-start;
	width: 30%;
}

.center{
	justify-content: center;
	width: 40%;
}

.after{
	justify-content: flex-end;
	width: 30%;
}
header{
	height: 90px;
	width: 100vw;
	display: flex;
	align-items: center;
	padding: 0 10px;
	justify-content: space-between;
	position: fixed;
	top: 0;
	left: 0;
	z-index: 30;
	background-color: #005CB9;
}

header nav > *{
	color: #fff;
	cursor: pointer;
	margin-right: 10px;
	font-size: 14px;
	text-transform: uppercase;
	font-weight: 400;
	text-decoration: none;
}

header nav > *:hover{
	text-decoration: underline;
}

.header-absolute{
	position: absolute;
}

img{
	cursor: pointer;
	display: block;
	height: 32px;
}

.menus-container{
	left: 0;
	top: 100%;
	width: 100%;
	z-index: 20;
	position: absolute;
	background-color: #fff;
}

/*Extra small < 600px*/
@media (min-width: 0) and (max-width: 600px) {
}

/*Small	sm	Small to medium tablet	600px > < 960px*/
@media (min-width: 601px) and (max-width: 960px) {
}

/*Medium	md	Large tablet to laptop	960px > < 1264px**/
@media (min-width: 961px) and (max-width: 1264px) {	
}

/*Large	lg	Desktop	1264px > < 1904px**/
@media (min-width: 1265px) and (max-width: 1904px) {
	header{
		padding: 0 100px;
	}
}

/*Extra large	xl	4k and ultra-wide*/
@media (min-width: 1904px) {
	header{
		padding: 0 100px;
	}
}

</style>